import React from 'react';
import type { TooltipProps } from 'recharts';
import styles from './ChartTooltip.module.scss';

interface ChartTooltipProps extends TooltipProps<number, string> {
  valueFormatter?: (value: number | string) => string;
}

const ChartTooltip: React.FC<ChartTooltipProps> = ({ active, payload, label, valueFormatter }) => {
  if (!active || !payload || payload.length === 0) return null;

  const fmt = (v: number | string | undefined) =>
    v === undefined ? '' : valueFormatter ? valueFormatter(v) : `${v}`;

  return (
    <div className={styles.tooltip}>
      {label !== undefined && label !== '' && <div className={styles.label}>{label}</div>}
      <div className={styles.rows}>
        {payload.map((entry, i) => (
          <div key={i} className={styles.row}>
            <span className={styles.swatch} style={{ background: entry.color }} />
            <span className={styles.name}>{entry.name}</span>
            <span className={styles.value}>{fmt(entry.value as number | string | undefined)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChartTooltip;
